import(/* webpackMode: "eager", webpackExports: ["fetchWithInterceptorInstance","use"] */ "/app/src/classes/FetchWithInterceptor.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/car-details-v2/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/car-details/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/translations/client-setup.ts");
